
import React from 'react'
import PartnerLogo from './PartnerLogo'
import urls from '@/utils/urls/urls'

const PartnerLogoContainer = async () => {
    const partnerLogoRes = await fetch(urls?.partnersLogo, {
        next: { revalidate: 3600 }, // revalidate after 1 hour (3600 seconds)
      });
    const partnerLogoData = await partnerLogoRes.json()
    const partnerLogo = Array.isArray(partnerLogoData?.data) ? partnerLogoData?.data : [];
    // cl("partnerLogoData", partnerLogo)
    return (
        <>
            <div
                className=" pt-70 pb-120"
            // style={{ backgroundImage: "url(../assets/img/cta/01.jpg)" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 mx-auto">
                            <div className="cta-content wow fadeInUp" data-wow-delay=".25s">
                                <h1 className="text-primary">
                                    Our Valuable <span className="text-secondary">Pertners</span>
                                </h1>
                                <div className="heading-divider" />
                                {/* <p>
                      It is a long established fact that a reader will be distracted
                      by the readable content of a page when the majority have
                      suffered alteration looking at its layout.
                    </p> */}
                                {/* <Link href="contact" className="theme-btn">
                      Contact Now
                      <i className="fas fa-arrow-right" />
                    </Link> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="partner-area pa-negative">
                <div className="container pb-5">
                    <PartnerLogo logo={partnerLogo} />
                </div>
            </div>
        </>
    )
}

export default PartnerLogoContainer
